module.exports = __webpack_public_path__ + "static/media/icon-pen.ccda5a8a.svg";